// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2932a6e4","453":"36fd05df","732":"9d513bea"}[chunkId] + ".chunk.js";
};